<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100">
    <div class="bg-white p-8 rounded-xl shadow-lg w-full max-w-md">
      <div class="text-center mb-8">
        <img src="/assets/logo.png" alt="AMGO" class="h-16 mx-auto mb-4" />
        <h1 class="text-2xl font-bold text-gray-900">Administration</h1>
        <p class="text-gray-500 mt-1">Connectez-vous pour gérer les actualités</p>
      </div>

      <form @submit.prevent="login" class="space-y-5">
        <div>
          <label for="email" class="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input
            id="email"
            type="email"
            v-model="email"
            required
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
            placeholder="admin@amgoran.dz"
          />
        </div>

        <div>
          <label for="password" class="block text-sm font-medium text-gray-700 mb-1">Mot de passe</label>
          <input
            id="password"
            type="password"
            v-model="password"
            required
            class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />
        </div>

        <div class="text-red-600 text-sm" v-if="error">{{ error }}</div>

        <button
          type="submit"
          :disabled="loading"
          class="w-full bg-indigo-600 text-white py-3 rounded-lg font-semibold hover:bg-indigo-700 transition-colors disabled:opacity-50 flex items-center justify-center"
        >
          <svg v-if="loading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
          </svg>
          {{ loading ? 'Connexion...' : 'Se connecter' }}
        </button>
      </form>

      <div class="mt-6 text-center">
        <a href="/" class="text-sm text-indigo-600 hover:underline">Retour au site</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminLogin",
  data() {
    return { email: "", password: "", error: "", loading: false };
  },
  mounted() {
    const token = localStorage.getItem("admin_token");
    if (token) this.$router.push("/admin/dashboard");
  },
  methods: {
    async login() {
      this.error = "";
      this.loading = true;
      try {
        const res = await fetch(`${process.env.VUE_APP_HSERVER_URL}/api/auth/login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: this.email, password: this.password }),
        });
        const data = await res.json();
        if (!res.ok) {
          this.error = data.error || "Erreur de connexion";
          return;
        }
        localStorage.setItem("admin_token", data.token);
        localStorage.setItem("admin_user", JSON.stringify(data.admin));
        this.$router.push("/admin/dashboard");
      } catch (err) {
        this.error = "Impossible de se connecter au serveur";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
